import React from 'react';
import 'src/scss/new-scss/components/LeftContent.scss';
import Pagination from 'src/new-ui/library/Pagination';
import CaseCard from 'src/new-ui/library/CaseCard';
import TabComponent from 'src/new-ui/library/TabComponent';
import { Grid } from '@material-ui/core';
import { getCases } from 'src/services/dashboard.service';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { setCaseDetail, setCaseToggleOption, setCaseId, setCaseNumber } from 'src/new-ui/features/NewDashboard/state/newDashboardAction.js';

import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import intl from 'react-intl-universal';
import { fnSetIsAllDataFlag, fnGetIsAllDataFlag } from 'src/helpers/commonFunctions';
import { isApplicantSelector } from 'src/ui/features/Login/state/loginReselect';
import deepOmit from 'src/helpers/deepOmit';

export class LeftContentContainer extends React.Component {
  state = {
    payload: {
      pageNumber: 1,
      filter: true,
      pageSize: 15,
      searchText: '',
      sortDirection: 'desc',
      sortColumn: 'targetDate',
      isAllData: fnGetIsAllDataFlag(),
      caseStateCode: 1,
    },
    selectedTab: sessionStorage.getItem('selectedTab') ? parseInt(sessionStorage.getItem('selectedTab')) : 0,
    caseResponseData: null,
    isLoading: true,
    totalPage: 0,
    totalCaseCount: 0,
    shouldLoadFirstRecord: true,
    counter: 0,
    pageCounter: 0,
    loadCount: 0,
    isPageLoad: true,
  };

  constructor(props) {
    super(props);
    this.search = debounce(this.getList, 1000);
  }

  getList = () => {
    this.setState({ loadCount: 1 });
    this.getDashboardCaseList(true, this.state.isPageLoad);
  };

  getCaseStateCode = code => {
    if (code === 0) return 1;
    else if (code === 1) return 0;
    else return code;
  };

  getTotalPageCount = () => {
    let size = Math.ceil(this.state.totalCaseCount / this.state.payload.pageSize);
    this.setState(prevState => ({
      totalPage: size,
    }));
  };

  getDashboardCaseList = (shouldUpdatePageCount = false, isPageLoad = false) => {
    let params = this.state.payload;
    if (isPageLoad) {
      let selectedTab = sessionStorage.getItem('selectedTab') ? parseInt(sessionStorage.getItem('selectedTab')) : 0;
      if (selectedTab === 0) {
        params.caseStateCode = 1;
      } else if (selectedTab === 1) {
        params.caseStateCode = 0;
      } else {
        params.caseStateCode = selectedTab;
      }
      params.caseId = sessionStorage.getItem('caseId') ? sessionStorage.getItem('caseId') : null;
      this.setState(prevState => ({ selectedTab: selectedTab }));
    } else {
      params.caseId = null;
    }

    getCases(params).then(response => {
      if (!response) {
        return;
      }
      if (typeof response.dashboardCases === 'undefined') {
        throw new Error('onRequestData expected API response to contain `rows`');
      }
      this.setState(
        prevState => ({
          caseResponseData: response,
          isLoading: false,
          totalCaseCount: response.totalCaseCount,
          payload: { ...prevState.payload, pageNumber: response.currentPageNumber },
          counter: this.state.counter > 0 ? this.state.counter - 1 : 0,
          pageCounter: this.state.pageCounter > 0 ? this.state.pageCounter - 1 : 0,
        }),
        () => {
          if (shouldUpdatePageCount) {
            this.getTotalPageCount();
          }
        },
      );
    });
  };

  getCaseCardTileComponent = () => {
    const data = this.state.caseResponseData.dashboardCases;
    if (data.length > 0 && this.state.counter === 0) {
      let cardTileComponent = [];
      for (let i = 0; i < data.length; i++) {
        cardTileComponent.push(<CaseCard id={this.getIndex(i)} data={data[i]} handleClickOnCase={this.handleClickOnCase} />);
      }
      const caseId = sessionStorage.getItem('caseId') ? sessionStorage.getItem('caseId') : null;
      let selectedData = null;
      if (caseId) {
        if (this.state.caseResponseData.totalCaseCount > 5000) {
          selectedData = data[0];
        } else {
          const sessionCaseData = data.find(x => x.caseId === caseId);
          if (sessionCaseData) {
            selectedData = sessionCaseData;
          } else {
            selectedData = data[0];
          }
        }
      } else {
        if (this.state.shouldLoadFirstRecord) {
          selectedData = data[0];
        }
      }
      if (selectedData) {
        this.handleClickOnCase(0, selectedData);
      }
      return cardTileComponent;
    }

    if (data.length === 0) {
      this.props.setCaseId(null);
      this.props.setCaseNumber(null);
      this.props.setCaseDetail(null);
      return (
        <span
          style={{
            display: 'block',
            textAlign: 'center',
            marginTop: '4.5rem',
          }}>
          {intl.get('newDashboard.common.noItemtoDisplay')}
        </span>
      );
    }
  };

  getIndex = index => {
    return this.state.payload.pageSize * (this.state.payload.pageNumber - 1) + index;
  };

  handleClickOnFirstPage = () => {
    if (this.state.pageCounter === 0) {
      if (this.state.payload.pageNumber === 1) {
        return;
      } else {
        this.setState(
          prevState => ({
            payload: { ...prevState.payload, pageNumber: 1 },
            isLoading: true,
            caseResponseData: null,
            shouldLoadFirstRecord: false,
            pageCounter: this.state.pageCounter + 1,
          }),
          () => {
            this.getDashboardCaseList();
          },
        );
      }
    } else {
      return;
    }
  };

  handleClickOnLastPage = () => {
    if (this.state.pageCounter === 0) {
      if (this.state.payload.pageNumber === this.state.totalPage) {
        return;
      } else {
        this.setState(
          prevState => ({
            payload: { ...prevState.payload, pageNumber: this.state.totalPage },
            isLoading: true,
            caseResponseData: null,
            shouldLoadFirstRecord: false,
            pageCounter: this.state.pageCounter + 1,
          }),
          () => {
            this.getDashboardCaseList();
          },
        );
      }
    } else {
      return;
    }
  };

  handleClickOnPreviousPage = () => {
    if (this.state.pageCounter === 0) {
      if (this.state.payload.pageNumber === 1) {
        return;
      } else {
        this.setState(
          prevState => ({
            payload: { ...prevState.payload, pageNumber: this.state.payload.pageNumber - 1 },
            isLoading: true,
            caseResponseData: null,
            shouldLoadFirstRecord: false,
            pageCounter: this.state.pageCounter + 1,
          }),
          () => {
            this.getDashboardCaseList();
          },
        );
      }
    } else {
      return;
    }
  };

  handleClickOnNextPage = () => {
    if (this.state.pageCounter === 0) {
      if (this.state.payload.pageNumber < this.state.totalPage) {
        this.setState(
          prevState => ({
            payload: { ...prevState.payload, pageNumber: this.state.payload.pageNumber + 1 },
            isLoading: true,
            caseResponseData: null,
            shouldLoadFirstRecord: false,
            pageCounter: this.state.pageCounter + 1,
          }),
          () => {
            this.getDashboardCaseList();
          },
        );
      } else {
        return;
      }
    } else {
      return;
    }
  };

  handleClickOnCase = (index, data, newDashboardState) => {
    if (data) {
      if (newDashboardState && newDashboardState.caseId === data.caseId) {
        return;
      }
      sessionStorage.setItem('caseId', data.caseId);
      sessionStorage.setItem('selectedTab', this.state.selectedTab);
      let currentIndex = 0;
      const cardData = this.state.caseResponseData.dashboardCases;
      for (let i = 0; i < cardData.length; i++) {
        if (data === cardData[i]) {
          data.setCardActive = true;
          currentIndex = i;
        } else {
          cardData[i].setCardActive = false;
        }
      }
      this.props.setCaseId(data.caseId);
      this.props.setCaseNumber(data.ticketNumber);
      this.props.setCaseDetail(data);
      if (this.state.loadCount === 1 && currentIndex) {
        const parentDiv = document.getElementById('divParentContent');
        const childDiv = document.getElementById('div_' + data.caseId);
        if (childDiv && parentDiv) {
          this.setState({ loadCount: 2 });
          parentDiv.scrollTop = childDiv.scrollHeight * currentIndex + 1;
        }
      }
    }
  };

  handleFilterSearch = searchText => {
    if (searchText) {
      this.setState({ isPageLoad: false });
    }
    this.setState({ isLoading: true, caseResponseData: null, totalCaseCount: 0 });
    let payload = this.state.payload;
    payload.searchText = searchText;
    payload.pageNumber = 1;
    this.applyFilters(payload);
  };

  applyFilters = payload => {
    this.setState(
      {
        payload,
      },
      () => {
        this.search();
      },
    );
  };

  handleOnToggleChange = flag => {
    this.props.setCaseToggleOption(flag);
    fnSetIsAllDataFlag(flag);
    this.setState(
      prevState => ({
        isLoading: true,
        shouldLoadFirstRecord: true,
        caseResponseData: null,
        payload: { ...prevState.payload, isAllData: flag, pageNumber: 1 },
      }),
      () => {
        this.getDashboardCaseList(true);
      },
    );
  };

  handleOnChange = async newValue => {
    if (sessionStorage.getItem('caseId')) {
      sessionStorage.removeItem('caseId');
    }
    await this.setState(
      prevState => ({
        selectedTab: newValue,
        payload: { ...prevState.payload, caseStateCode: this.getCaseStateCode(newValue), pageNumber: 1 },
        isLoading: true,
        caseResponseData: null,
        shouldLoadFirstRecord: true,
        totalCaseCount: 0,
        counter: this.state.counter + 1,
        pageCounter: 0,
      }),
      () => {
        this.getDashboardCaseList(true);
      },
    );
  };

  onApplyFilter = filter => {
    this.setState(
      prevState => ({
        payload: { ...prevState.payload, pageNumber: 1, ...filter },
        isLoading: true,
        caseResponseData: null,
        totalCaseCount: 0,
      }),
      () => {
        this.applyFilters(this.state.payload);
      },
    );
  };

  onClearFilter = filter => {
    this.setState(
      prevState => ({
        payload: deepOmit(prevState.payload, Object.keys(filter)),
        isLoading: true,
        caseResponseData: null,
        totalCaseCount: 0,
      }),
      () => {
        this.applyFilters(this.state.payload);
      },
    );
  };

  handlePillClear = key => {
    let removeFromPayload = this.state.payload;
    delete removeFromPayload[key];
    this.setState(
      prevState => ({
        payload: { ...removeFromPayload, pageNumber: 1 },
        isLoading: true,
        caseResponseData: null,
        totalCaseCount: 0,
      }),
      () => {
        this.getDashboardCaseList(true);
      },
    );
  };

  render() {
    const selectedTab = this.state.selectedTab;
    const tabs1 = [
      {
        getTitle: () => intl.get('newDashboard.caseCard.activeCases'),
        content: (
          <section>
            {' '}
            {this.state.totalCaseCount > 0 && this.state.counter === 0 ? (
              <Pagination
                handleClickOnFirstPage={this.handleClickOnFirstPage}
                handleClickOnLastPage={this.handleClickOnLastPage}
                handleClickOnPreviousPage={this.handleClickOnPreviousPage}
                handleClickOnNextPage={this.handleClickOnNextPage}
                totalPage={this.state.totalPage}
                pageNumber={this.state.payload.pageNumber}
              />
            ) : null}
            <div className="left-panel-height" id="divParentContent">
              {selectedTab === 0 &&
                this.state.caseResponseData &&
                this.state.caseResponseData.dashboardCases &&
                this.getCaseCardTileComponent()}
              {selectedTab === 0 && this.state.isLoading ? (
                <div style={{ margin: '10px 0px 10px 0px' }}>
                  <Spinner size={30} />
                </div>
              ) : null}
            </div>
          </section>
        ),
      },
      {
        getTitle: () => intl.get('newDashboard.caseCard.inactiveCases'),
        content: (
          <section>
            {' '}
            {this.state.totalCaseCount > 0 && this.state.counter === 0 ? (
              <Pagination
                handleClickOnFirstPage={this.handleClickOnFirstPage}
                handleClickOnLastPage={this.handleClickOnLastPage}
                handleClickOnPreviousPage={this.handleClickOnPreviousPage}
                handleClickOnNextPage={this.handleClickOnNextPage}
                totalPage={this.state.totalPage}
                pageNumber={this.state.payload.pageNumber}
              />
            ) : null}
            <div className="left-panel-height" id="divParentContent">
              {selectedTab === 1 &&
                this.state.caseResponseData &&
                this.state.caseResponseData.dashboardCases &&
                this.getCaseCardTileComponent()}
              {selectedTab === 1 && this.state.isLoading ? (
                <div style={{ margin: '10px 0px 10px 0px' }}>
                  <Spinner size={30} />
                </div>
              ) : null}
            </div>
          </section>
        ),
      },
      {
        getTitle: () => intl.get('newDashboard.caseCard.allCases'),
        content: (
          <section>
            {' '}
            {this.state.totalCaseCount > 0 && this.state.counter === 0 ? (
              <Pagination
                handleClickOnFirstPage={this.handleClickOnFirstPage}
                handleClickOnLastPage={this.handleClickOnLastPage}
                handleClickOnPreviousPage={this.handleClickOnPreviousPage}
                handleClickOnNextPage={this.handleClickOnNextPage}
                totalPage={this.state.totalPage}
                pageNumber={this.state.payload.pageNumber}
              />
            ) : null}
            <div className="left-panel-height" id="divParentContent">
              {selectedTab === 2 &&
                this.state.caseResponseData &&
                this.state.caseResponseData.dashboardCases &&
                this.getCaseCardTileComponent()}
              {selectedTab === 2 && this.state.isLoading ? (
                <div style={{ margin: '10px 0px 10px 0px' }}>
                  <Spinner size={30} />
                </div>
              ) : null}
            </div>
          </section>
        ),
      },
    ];

    return (
      <Grid container className="left-content">
        <Grid item sm={12}>
          {/* <Grid item className="panel-search-container">
            <div className="d-flex">
              <Filter /> <Searchbar />
            </div>
          </Grid> */}
          <TabComponent
            tabs1={tabs1}
            defaultTabIndex={this.state.selectedTab}
            onFilterSearch={this.handleFilterSearch}
            onChange={newValue => this.handleOnChange(newValue)}
            toggleChange={value => this.handleOnToggleChange(value)}
            switchSelected={this.state.payload.isAllData}
            isApplicant={this.props.isApplicant}
            onApplyFilter={this.onApplyFilter}
            onClearFilter={this.onClearFilter}
            handlePillClear={this.handlePillClear}
          />
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = state => {
  return {
    isApplicant: isApplicantSelector(state),
  };
};
const mapDispatchToProps = {
  setCaseDetail,
  setCaseToggleOption,
  setCaseId,
  setCaseNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftContentContainer);
